import angular from 'angular';
import sourceErrorsModalComponent from './sourceErrorsModal.component';

let sourceErrorsModalModule = angular.module('sourceErrorsModal', []).component('sourceErrorsModal', sourceErrorsModalComponent);

export default sourceErrorsModalModule;



// WEBPACK FOOTER //
// ./app/components/sourceErrorsModal/sourceErrorsModal.js